import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'logic-label',
    styleUrls: [ 'custom-entity-search.cmp.scss' ],
    template: `
        <!-- <div class="logic-label">
            {{ logic }}
        </div> -->
        <div class="logic-toggle-container">
            <div class="logic-toggle">
                <button
                    class="logic-toggle-btn left caption caption--sm"
                    [class.active]="(logic | async) === 'AND'"
                    (click)="setLogic('AND')"
                    type="button"
                >
                        AND
                </button>
                <div class="separator"></div>
                <button
                    class="logic-toggle-btn right caption caption--sm"
                    [class.active]="(logic | async) === 'OR'"
                    (click)="setLogic('OR')"
                    type="button"
                >
                    OR
                </button>
            </div>
            <button class="reset-btn caption" (click)="editOptions()">
                <svg class="nu-icon">
                    <use xlink:href="./assets/icons/symbol-defs.svg#nu-ic-reset"></use>
                </svg>
                <span>{{ 'LABELS.RESET' | translate }}</span>
            </button>
        </div>
    `,
})

export class LogicLabelComponent implements OnInit {

    @Input() public logic: BehaviorSubject<string>;

    @Output() remove = new EventEmitter<void>();

    public showOptions: boolean = false;

    constructor() { }

    ngOnInit() { }

    public editOptions() {
        this.logic.next('');
        this.remove.emit();
        this.showOptions = false;
    }

    public setLogic(type: 'AND' | 'OR' | '') {
        this.logic.next(type);
    }

    public addAnd() {
        this.logic.next( 'AND' );
        this.showOptions = false;
    }
    public addOr() {
        this.logic.next( 'OR' );
        this.showOptions = false;
    }
}